// @flow
import * as React from 'react';

type Props = {
  children: React.Node
};

type State = {
  updateRequired: boolean
};

const UpdateRequiredContext: Object = React.createContext<boolean>(false);

export default UpdateRequiredContext;

export class UpdateRequiredContextProvider extends React.PureComponent<
  Props,
  State
> {
  state = {
    updateRequired: false
  };

  componentDidMount() {
    window.Idealist = window.Idealist || {};
    window.Idealist.forceUpdate = () => {
      this.setState({ updateRequired: true });
      return true;
    };
  }

  render() {
    return (
      <UpdateRequiredContext.Provider value={this.state.updateRequired}>
        {this.props.children}
      </UpdateRequiredContext.Provider>
    );
  }
}
